import { useEffect, useState } from "react";
import api from "../../api/client";

/* Full PDS/ADS record detail — fetches all fields and shows them as a grid. */
export default function PdsAdsDetailModal({ recordId, onClose }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError("");
    api
      .get(`/pds-ads/${recordId}`)
      .then(({ data }) => { if (!cancelled) setData(data); })
      .catch((err) => { if (!cancelled) setError(err.response?.data?.detail || "Failed to load record."); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [recordId]);

  const title =
    data?.fields?.find((f) => f.field === "full_name")?.value ||
    data?.fields?.find((f) => f.field === "subscriber_name")?.value ||
    "PDS/ADS Record";

  return (
    <div className="fixed inset-0 z-[9990] flex items-center justify-center bg-black/40 p-4" onMouseDown={onClose}>
      <div
        className="bg-white rounded-lg shadow-xl w-full max-w-4xl max-h-[88vh] flex flex-col"
        onMouseDown={(e) => e.stopPropagation()}
      >
        <div className="flex items-start justify-between px-5 py-4 border-b">
          <div>
            <h2 className="text-lg font-bold text-gray-800">{title}</h2>
            <p className="text-sm text-gray-500">Disconnected subscriber — full record</p>
          </div>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-700 text-2xl leading-none">×</button>
        </div>

        <div className="overflow-auto px-5 py-4">
          {loading ? (
            <div className="py-12 text-center text-gray-500">Loading…</div>
          ) : error ? (
            <div className="py-12 text-center text-red-600">{error}</div>
          ) : (
            <dl className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-3">
              {data.fields.map((f) => (
                <div key={f.field} className="min-w-0">
                  <dt className="text-[11px] font-semibold uppercase tracking-wide text-gray-400">{f.label}</dt>
                  <dd className="text-sm text-gray-800 break-words">{f.value || <span className="text-gray-300">—</span>}</dd>
                </div>
              ))}
            </dl>
          )}
        </div>

        <div className="px-5 py-3 border-t flex justify-end">
          <button onClick={onClose} className="bg-gray-100 hover:bg-gray-200 text-gray-700 text-sm font-medium px-4 py-1.5 rounded">
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
